import { AxiosError } from 'axios';
import { message } from 'antd';

export interface ApiError {
  message: string;
  code?: string;
  field?: string;
  statusCode?: number;
}

export const handleApiError = (error: unknown): ApiError => {
  if (error instanceof AxiosError) {
    const statusCode = error.response?.status;
    const data = error.response?.data;

    switch (statusCode) {
      case 400:
        return {
          message: data?.message || 'Invalid request',
          code: 'BAD_REQUEST',
          field: data?.field,
          statusCode,
        };

      case 401:
        return {
          message: 'Please log in to continue',
          code: 'UNAUTHORIZED',
          statusCode,
        };

      case 403:
        return {
          message: 'You do not have permission to perform this action',
          code: 'FORBIDDEN',
          statusCode,
        };

      case 404:
        return {
          message: data?.message || 'Resource not found',
          code: 'NOT_FOUND',
          statusCode,
        };

      case 422:
        return {
          message: data?.message || 'Validation error',
          code: 'VALIDATION_ERROR',
          field: data?.field,
          statusCode,
        };

      case 500:
        return {
          message: 'Server error. Please try again later',
          code: 'SERVER_ERROR',
          statusCode,
        };

      default:
        return {
          message: data?.message || 'An unexpected error occurred',
          code: 'UNKNOWN_ERROR',
          statusCode,
        };
    }
  }

  return {
    message: 'Network error. Please check your connection',
    code: 'NETWORK_ERROR',
  };
};

export const showErrorToast = (error: unknown) => {
  const apiError = handleApiError(error);
  message.error(apiError.message);
};
